module.exports = "/images/fcd0ab4960fb488ae683a2ca1db581cb.png";